import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ProjectCommunicationService } from './communication/project-comms.service';
import { Location } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { ConfiguredToastrService } from './helper/toastr/configured-toastr.service';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { CommunicationService } from './communication/communication.service';
import { RxStompService } from '@stomp/ng2-stompjs';
import Utils from './util';
import { AnessaTranslationService } from './helper/translation/anessa-translation.service';
import { Userpilot } from 'userpilot';
import { PreferencesService } from './header/topbar/preferences-dialog/preferences.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  title = 'app';
  private projectLoaded = false;
  translationServiceReady = false;

  private connectingToUserPilot = false;

  constructor(private projectService: ProjectCommunicationService,
              private authService: AuthService,
              private location: Location,
              private toasterService: ConfiguredToastrService,
              private commService: CommunicationService,
              private rxStompService: RxStompService,
              private translationService: AnessaTranslationService,
              private userPreferencesService: PreferencesService
  ) {
  }


  ngOnInit() {
    this.projectService.projectLoadedChange
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((value) => {
        // show content
        this.projectLoaded = value;
        if (value === true && !this.projectService.isProjectInput()) {
          this.toasterService.info(this.translationService.get('PROJECT.LOADED'));
        }
      });

    const projPreviouslyLoaded = this.isLoggedIn()
      && localStorage.getItem('projectID')
      && localStorage.getItem('projectID') !== 'null';

    if (!projPreviouslyLoaded) {
      this.projectService.unloadProject();
    }

    if (this.isLoggedIn()) {
      this.commService.connectToSocket(this.rxStompService);
      this.commService.connectToMetrics();
      this.commService.subscribeToErrors(this.rxStompService);
      this.commService.fetchReachedProjectLimit();
      this.connectToUserpilot();
    }

    const projectID = localStorage.getItem('projectID');
    if (projectID && projPreviouslyLoaded && this.location.path() !== '/home') {
      this.projectService.retrieveProjectFromDatabase(projectID, this.location.path());
    }

    this.authService.loggedInNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((loggedIn: boolean) => {
        if (loggedIn) {
          this.connectToUserpilot();
          this.loadUserPreferences();
          const languages = localStorage.getItem('availableLanguages');
          if (languages && languages.length) {
            this.translationService.setAvailableLanguages(languages.split(','));
          }
        } else {
          this.userPreferencesService.unloadUserPreferences();
        }
      });

    this.translationService.translationReadyNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .pipe(takeWhile(x => !x, true))
      .subscribe(loaded => {
        if (loaded) {
          this.translationServiceReady = loaded;
          console.log('TRANSLATIONS SERVICE READY');
        }
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  connectToUserpilot() {
    if (this.connectingToUserPilot) return;
    const userID = localStorage.getItem('userID');
    if (userID) {
      this.connectingToUserPilot = true;
      // ISO8601 format (YYYY-MM-DD)
      const userName = localStorage.getItem('userFirstName') + ' ' +
        localStorage.getItem('userLastName');
      const accountName = localStorage.getItem('accountName');
      Userpilot.identify(
        userID, {
          name: userName,
          email: localStorage.getItem('userEmail'),
          company:  // optional
            {
              id: accountName, // Company Unique ID
            }
          // plan: null,
          // trialEnds: null // ISO0861
        }
      )
    }
  }

  private loadUserPreferences() {
    this.userPreferencesService.initializeUserPreferences();
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  isContentShown() {
    if (!this.projectLoaded && this.isLoggedIn()) {
      // login
      return true;
    } else if (!this.isLoggedIn() || this.projectLoaded) {
      return true;
    }

    return false;
  }

  isInitialFormUser() {
    return Utils.isInitialFormUser();
  }

  private startsWithFromArray(myPath: string, myArray: string[]): boolean {
    for (const item of myArray) {
      if (myPath.startsWith(item)) {
        return true;
      }
    }
    return false;
  }

  shouldShowTabs() {
    return (
      this.isLoggedIn()
      && !this.isInitialFormUser()
      && this.projectLoaded
      && !this.startsWithFromArray(this.location.path(), ['/project-input', '/scoping-results'])
    );
  }
}
